import type { CacheValue } from './type';

import { deepCopy } from '~/utils';

export const isLoadingData = <T>(key: string, cache: Record<string, CacheValue<T>>): boolean => {
  return !cache[key] || typeof cache[key]?.data === 'undefined';
};

export const getCachedData = <T>(
  key: string,
  cache: Record<string, CacheValue<T>>,
): T | undefined => {
  return deepCopy(cache[key]?.data) as T | undefined;
};

export const findCacheKeyByRequestId = <T>(
  cache: Record<string, CacheValue<T>>,
  requestId: string,
): string | undefined =>
  Object.entries(cache).find(([, value]) => value.requestId === requestId)?.[0];
